.monaco-editor .margin-view-overlays .current-line,.monaco-editor .view-overlays .current-line{box-sizing:border-box;display:block;height:100%;left:0;position:absolute;top:0}.monaco-editor
	.margin-view-overlays
	.current-line.current-line-margin.current-line-margin-both{border-right:0}